<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!--    <template #header>-->
    <!--      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>-->
    <!--    </template>-->

    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tìm kiếm nâng cao
      </h5>
    </template>

    <template #body>
      <el-form
        :model="advanceSearchForm"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Trích yếu" class="formItem">
              <el-input
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.quote"
                size="medium"
                placeholder="Trích yếu"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Số ký hiệu" class="formItem">
              <el-input
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.docCode"
                size="medium"
                placeholder="Số ký hiệu"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="Ngày văn bản" class="formItem">
              <el-date-picker
                v-model="docDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                :clearable="false"
                @change="docDateRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>

      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fal fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
        >Xóa
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
  import constants from "../../../constants";
  import dateUtils from "../../../dateUtils";
  import utils from "../../../services/utils";
  import CustomDialog from "../../common/custom-dialog";

  export default {
    name: "tdhvp-doc-in-advance-search-dialog",
    props: ["isOpen", "form"],
    components: {
      CustomDialog
    },

    computed: {},

    data() {
      return {
        docDateRange: null,
        advanceSearchForm: {
          docCode: null,
          fromDocDate: null,
          toDocDate: null,
          quote: null,
        },
        dateQuickFilterOption: null,
      };
    },

    created() {
      this.dateQuickFilterOption = utils.getDefaultDateQuickFilterOption();
      this.initForm();
    },

    methods: {

      search() {
        this.$emit("doSearch", {
          docCode: this.advanceSearchForm.docCode,
          fromDocDate: this.advanceSearchForm.fromDocDate,
          toDocDate: this.advanceSearchForm.toDocDate,
          quote: this.advanceSearchForm.quote
        })
      },

      reset() {
        this.advanceSearchForm.docCode = null;
        this.advanceSearchForm.fromDocDate = null;
        this.advanceSearchForm.toDocDate = null;
        this.advanceSearchForm.quote = null;
        this.initDocDateRange();
      },

      docDateRangeChanged() {
        utils.timeRangeChanged(this.docDateRange, (from_, to_) => {
          this.advanceSearchForm.fromDocDate = from_;
          this.advanceSearchForm.toDocDate = to_;
        });
      },

      initForm() {
        this.advanceSearchForm.docCode = this.form.docCode;
        this.advanceSearchForm.fromDocDate = this.form.fromDocDate;
        this.advanceSearchForm.toDocDate = this.form.toDocDate;
        this.advanceSearchForm.quote = this.form.quote;
        this.initDocDateRange();
      },

      initDocDateRange() {
        if (
          !this.advanceSearchForm.fromDocDate ||
          !this.advanceSearchForm.toDocDate
        ) {
          utils.timeRangeChanged(
            (this.docDateRange = dateUtils.getDatesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR_2
            )),
            (from_, to_) => {
              this.advanceSearchForm.fromDocDate = from_;
              this.advanceSearchForm.toDocDate = to_;
            }
          );
        } else {
          this.docDateRange = [
            new Date(this.advanceSearchForm.fromDocDate),
            new Date(this.advanceSearchForm.toDocDate)
          ];
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/doc-in/tdhvp-doc-in-advance-search-dialog.vue